import * as Yup from 'yup';
import moment from 'moment';
const mustBeANumber = 'Must be a number.';
const requiredFieldText = 'This field is required';
const invalidEmailString = 'Invalid email address or missing comma separator.';
const emailAddressRequiredText = 'Must include at least 1 email address.'
const duplicateEmail = 'Email address should not be duplicate';
export const numberRegEXp = /^\d+$/;
const passwordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;

export const CardExpSchema = Yup.number().required(requiredFieldText).test("expirationm", "Expiration date must be in the future.", function () {
  let { card_expMonth, card_expYear } = this.parent;
  let curMonth = moment().month();
  let curYear = moment().year();
  if (parseInt(card_expYear) > curYear) return true;
  if (parseInt(card_expMonth) >= (curMonth + 1)) return true;
  return false;
})

export const LoginSchema = Yup.object().shape({
  email: Yup.string().required(requiredFieldText),
  password: Yup.string().required(requiredFieldText)
});

export const AddressSchema = Yup.object().shape({
  address1: Yup.string().required(requiredFieldText),
  zip: Yup.string().required(requiredFieldText),
  city: Yup.string().required(requiredFieldText),
  state: Yup.string().required(requiredFieldText)
});

export const ResetPasswordSchema = Yup.object().shape({
  oldPassword: Yup.string().required(requiredFieldText),
  newPassword: Yup.string().required(requiredFieldText)
    .min(8, 'Password too short! Must be at least 8 characters in length')
    .matches(passwordRegExp,
      "Password must contain One Uppercase, One Lowercase, One Number and one special case Character"
    ),
  newPasswordConfirm: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], "Passwords must match")
    .required(requiredFieldText)
});

export const ResetPasswordTokenSchema = Yup.object().shape({
  newPassword: Yup.string().required(requiredFieldText)
    .min(8, 'Password too short! Must be at least 8 characters in length')
    .matches(passwordRegExp,
      "Password must contain One Uppercase, One Lowercase, One Number and one special case Character"
    ),
  newPasswordConfirm: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], "Passwords must match")
    .required(requiredFieldText)
});

export const ResetPasswordRequestSchema = Yup.object().shape({
  email: Yup.string().required(requiredFieldText)
});


export const RatingFormSchema = Yup.object().shape({
  reviewingUser: Yup.string().required(requiredFieldText),
  values: Yup.array().of(Yup.number().moreThan(0))
});

export const RatingResponseSchema = Yup.object().shape({
  response: Yup.string().required()
});

export const ContactFormSchema = Yup.object().shape({
  userId: Yup.string().required(),
  message: Yup.string().required()
});

export const ShareFormSchema = Yup.object().shape({
  recipients: Yup.string()
    .test('test-emails', invalidEmailString,
      function (value) {
        if (!value) { return true; }
        var isValidEmail = false;
        // split email list into an array, filter out blanks & periods
        var emails = value.split(/\s*(?:,|;)\s*/).filter(function (e) { return e !== "" && e !== "." });
        for (var i = 0; i < emails.length; i++) {
          let schema = Yup.string().email();
          let result = schema.isValidSync(emails[i]);
          if (!result) {
            isValidEmail = false;
            break;
          }
          isValidEmail = true;
        }
        console.log("Emails", emails, isValidEmail)
        return isValidEmail;
      }
    )
    .test('test-mailduplicacy', duplicateEmail,
      function (value) {
        if (!value) { return true; }
        var emails = value.split(/\s*(?:,|;)\s*/).filter(function (e) { return e !== "" && e !== "." });

        function hasDuplicates(arr) {
          return new Set(arr).size !== arr.length;
        }

        if (hasDuplicates(emails)) {
          return false;
        }
        return true;
      }
    )
    .required(emailAddressRequiredText)
});




export const BlueSwipeCustomerFormSchema = Yup.object().shape({
  bill_firstName: Yup.string().required(requiredFieldText),
  bill_lastName: Yup.string().required(requiredFieldText),
  bill_address1: Yup.string().required(requiredFieldText),
  bill_zip: Yup.string().matches(numberRegEXp, mustBeANumber).required(requiredFieldText),
  bill_city: Yup.string().required(requiredFieldText),
  bill_state: Yup.string().required(requiredFieldText),
  card_number: Yup.number().required(requiredFieldText),
  card_expMonth: CardExpSchema,
  card_expYear: CardExpSchema,
  card_cvv: Yup.string().matches(/^\d+$/, {
    message: 'CVV must be a `number`.'
  }).required(requiredFieldText)
});

export const BlueSwipeIndAccountFormSchema = Yup.object().shape({
  bill_firstName: Yup.string().required(requiredFieldText),
  bill_lastName: Yup.string().required(requiredFieldText),
  bill_address1: Yup.string().required(requiredFieldText),
  bill_zip: Yup.string().matches(numberRegEXp, mustBeANumber).required(requiredFieldText),
  bill_city: Yup.string().required(requiredFieldText),
  bill_state: Yup.string().required(requiredFieldText),
  bnk_accountNumber: Yup.string().matches(numberRegEXp, mustBeANumber).required(requiredFieldText),
  bnk_routingNumber: Yup.string().matches(numberRegEXp, mustBeANumber).required(requiredFieldText)
});

export const BlueSwipeBusAccountFormSchema = Yup.object().shape({
  bill_businessName: Yup.string().required(requiredFieldText),
  bill_tin: Yup.string().matches(numberRegEXp, mustBeANumber).required(requiredFieldText),
  bill_firstName: Yup.string().required(requiredFieldText),
  bill_lastName: Yup.string().required(requiredFieldText),
  bill_address1: Yup.string().required(requiredFieldText),
  bill_zip: Yup.string().matches(numberRegEXp, mustBeANumber).required(requiredFieldText),
  bill_city: Yup.string().required(requiredFieldText),
  bill_state: Yup.string().required(requiredFieldText),
  bnk_accountNumber: Yup.string().matches(numberRegEXp, mustBeANumber).required(requiredFieldText),
  bnk_routingNumber: Yup.string().matches(numberRegEXp, mustBeANumber).required(requiredFieldText)
});
